export const WATCH_BLOCK_THEME_LOCAL_KEY = 'WATCH_BLOCK_THEME_LOCAL_KEY';
